<script>
import TemplateHeaderTableNew from '@/components/TemplateHeaderTableList'
import { getAction, downloadAction } from '@/command/netTool'
import { hotelMixin } from '@/mixins/orderProcessing/hotelMixin'
import { eatDrinkMixin } from '@/mixins/orderProcessing/eatDrinkMixin'
import { farmingExperienceMixin } from '@/mixins/orderProcessing/farmingExperienceMixin'
import { scenicAreasTicketsMixin } from '@/mixins/orderProcessing/scenicAreasTickets'
import { localProductsMixin } from '@/mixins/orderProcessing/localProductsMixin'
import { Tooltip } from 'ant-design-vue'
import Big from 'big.js'

export default {
  name: 'dataReportTeamTicket',
  data() {
    return {
      records: [],
      totalData: null,
      current: 1,
      total: 1,
      // listUrl: '/reportForm/getTicketScenicOrderPageV3',
      params: { current: 1, pageSize: 10 },
      paramsValue: {},
      orderIdList: [],
      loading: false,
    }
  },
  mixins: [hotelMixin, eatDrinkMixin, farmingExperienceMixin, scenicAreasTicketsMixin, localProductsMixin],
  mounted() {
    this.getList()
  },
  methods: {
    getTotal(params) {
      return new Promise((resolve) => {
        // if (this.totalData) {
        //   resolve(this.totalData)
        // } else {
        this.params = {
          ...this.params,
          ...params,
        }
        // getAction('/reportForm/getTicketScenicOrderTotalV3', this.params).then((e) => {
        //   this.totalData = e.data
        //   resolve(e.data)
        // })
        // }
      })
    },
    getSum(list) {
      let orderCount = 0
      let productQuantityCompleted = 0
      let productQuantity = 0
      let totalAmount = 0
      let totalAmountCompleted = 0
      let refundCount = 0
      let refundAmount = 0
      let salesJsAmount = 0
      let feeAmount = 0
      list.forEach((e) => {
        orderCount = parseFloat(new Big(e.orderCount || 0).plus(orderCount))
        productQuantityCompleted = parseFloat(new Big(e.productQuantityCompleted || 0).plus(productQuantityCompleted))
        productQuantity = parseFloat(new Big(e.productQuantity || 0).plus(productQuantity))
        totalAmount = parseFloat(new Big(e.totalAmount || 0).plus(totalAmount))
        totalAmountCompleted = parseFloat(new Big(e.totalAmountCompleted || 0).plus(totalAmountCompleted))
        refundCount = parseFloat(new Big(e.refundCount || 0).plus(refundCount))
        refundAmount = parseFloat(new Big(e.refundAmount || 0).plus(refundAmount))
        salesJsAmount = parseFloat(new Big(e.salesJsAmount || 0).plus(salesJsAmount))
        feeAmount = parseFloat(new Big(e.feeAmount || 0).plus(feeAmount))
      })
      return {
        businessName: '合计',
        orderCount,
        productQuantityCompleted,
        productQuantity,
        totalAmount,
        totalAmountCompleted,
        refundAmount,
        refundCount,
        salesJsAmount,
        feeAmount,
      }
    },
    getList(params = this.params) {
      // this.getTotal(params).then((total) => {
      this.loading = true
      getAction('/reportForm/getTeamOrderReportPage', params).then((e) => {
        this.params = { ...params }
        this.records = e.data['records']
        this.params['current'] = e.data['current']
        this.params['pageSize'] = e.data['pageSize']
        this.current = e.data['current']
        this.total = e.data['total']
        if (this.records.length !== 0) {
          // this.records.push({ ...total, productName: '总计', feeAmount: total.feeAmount })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
      // })
    },
    getHeader() {
      return [
        {
          type: 'input',
          name: '景区名称',
          key: 'businessName',
        },
        {
          name: '日期',
          type: 'rangePicker',
          keys: ['dateGe', 'dateLe'],
        },
      ]
    },
    getColumns() {
      return [
        {
          title: '景点名称',
          dataIndex: 'businessName',
          align: 'center',
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          align: 'center',
          customRender: (text, records) => {
            return (
              <div>
                {records.itemList.map((item, i) => {
                  return (
                    <div
                      style={{
                        borderTop: i == 0 ? 'none' : '1px solid #e1e1e1',
                        padding:
                          i == 0 ? (records.itemList.length == 1 ? '0px 0 0px 0px' : '0px 0 6px 0px') : '6px 0px',
                      }}
                    >
                      {item.productName || '-'}
                    </div>
                  )
                })}
              </div>
            )
          },
        },
        {
          title: '折扣',
          dataIndex: 'discount',
          align: 'center',
          customRender: (text, records) => {
            return (
              <div>
                {records.itemList.map((item, i) => {
                  return (
                    <div
                      style={{
                        borderTop: i == 0 ? 'none' : '1px solid #e1e1e1',
                        padding:
                          i == 0 ? (records.itemList.length == 1 ? '0px 0 0px 0px' : '0px 0 6px 0px') : '6px 0px',
                      }}
                    >
                      {item.discount || '-'}
                    </div>
                  )
                })}
              </div>
            )
          },
        },
        {
          title: '销售量',
          dataIndex: 'salesCount',
          align: 'center',
          customRender: (text, records) => {
            return (
              <div>
                {records.itemList.map((item, i) => {
                  return (
                    <div
                      style={{
                        borderTop: i == 0 ? 'none' : '1px solid #e1e1e1',
                        padding:
                          i == 0 ? (records.itemList.length == 1 ? '0px 0 0px 0px' : '0px 0 6px 0px') : '6px 0px',
                      }}
                    >
                      {item.salesCount || '-'}
                    </div>
                  )
                })}
              </div>
            )
          },
        },
        {
          title: '销售额',
          dataIndex: 'salesAmount',
          align: 'center',
          customRender: (text, records) => {
            return (
              <div>
                {records.itemList.map((item, i) => {
                  return (
                    <div
                      style={{
                        borderTop: i == 0 ? 'none' : '1px solid #e1e1e1',
                        padding:
                          i == 0 ? (records.itemList.length == 1 ? '0px 0 0px 0px' : '0px 0 6px 0px') : '6px 0px',
                      }}
                    >
                      {item.salesAmount || '-'}
                    </div>
                  )
                })}
              </div>
            )
          },
        },
        {
          title: '退票量',
          dataIndex: 'refundCount',
          align: 'center',
          customRender: (text, records) => {
            return (
              <div>
                {records.itemList.map((item, i) => {
                  return (
                    <div
                      style={{
                        borderTop: i == 0 ? 'none' : '1px solid #e1e1e1',
                        padding:
                          i == 0 ? (records.itemList.length == 1 ? '0px 0 0px 0px' : '0px 0 6px 0px') : '6px 0px',
                      }}
                    >
                      {item.refundCount || '-'}
                    </div>
                  )
                })}
              </div>
            )
          },
        },
        {
          title: '退票额',
          dataIndex: 'refundAmount',
          align: 'center',
          customRender: (text, records) => {
            return (
              <div>
                {records.itemList.map((item, i) => {
                  return (
                    <div
                      style={{
                        borderTop: i == 0 ? 'none' : '1px solid #e1e1e1',
                        padding:
                          i == 0 ? (records.itemList.length == 1 ? '0px 0 0px 0px' : '0px 0 6px 0px') : '6px 0px',
                      }}
                    >
                      {item.refundAmount || '-'}
                    </div>
                  )
                })}
              </div>
            )
          },
        },
      ]
    },
    onTransferData(data) {
      const list = data
      let productQuantity = 0
      let productQuantityCompleted = 0
      list.forEach((e) => {
        productQuantity += e.productQuantity
        productQuantityCompleted += e.productQuantityCompleted
      })
      list.push({ productQuantity, productQuantityCompleted })
      return data
    },
    onChange(data, filter) {
      this.getList(data)
    },
    getRightButton() {
      return [
        {
          name: '导出Excel',
          type: 'normal2',
          onClick: (data) => {
            const { businessName, status, dateGe, dateLe } = this.params
            console.log(this.params)
            let urlParam = ''
            if (businessName) {
              urlParam = urlParam + `businessName=${businessName}`
            }
            if (status) {
              urlParam = (urlParam ? `${urlParam}&` : urlParam) + `status=${status}`
            }
            if (this.orderIdList.length) {
              urlParam = (urlParam ? `${urlParam}&` : urlParam) + `&ids=${this.orderIdList}`
            }
            if (dateGe) {
              urlParam = (urlParam ? `${urlParam}&` : urlParam) + `&dateGe=${dateGe}&dateLe=${dateLe}`
            }
            downloadAction(`/api/reportForm/exportTeamOrderReport?${urlParam}`, '团队票报表.xlsx')
          },
        },
      ]
    },
    selectRow(data, records) {
      this.orderIdList = records.map((d) => d.id)
    },
  },
  render() {
    return (
      <TemplateHeaderTableNew
        records={this.records}
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        onChange={this.onChange}
        rightButton={this.getRightButton()}
        button={[]}
        filterRightButtonKey={['refresh', 'setting']}
        onSelectRow={this.selectRow}
      />
    )
  },
}
</script>
